import Dropzone from "react-dropzone";
import {
    Box,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Paper,
    styled,
    Tooltip,
    Typography
} from "@mui/material";
import {CameraAltRounded, CloudUploadRounded, MicRounded, MoreVertRounded} from "@mui/icons-material";
import {useRef, useState} from "react";

const UploadInput = (props) => {

    const {onChange, disabled, ...restProps} = props;
    const rootProps = (props) => !disabled ? props() : {}

    const isAndroid = navigator?.userAgent ? /(android)/i.test(navigator.userAgent) : false;
    const recAudioRef = useRef(null);
    const recImageRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const optionsOpen = Boolean(anchorEl);
    const handleOpenOptionsMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleCloseOptionsMenu = () => {
        setAnchorEl(null);
    };

    return (
        <Dropzone onDrop={acceptedFiles => onChange(acceptedFiles)}>
            {({getRootProps, getInputProps}) => (
                <Wrapper {...rootProps(getRootProps)} {...restProps} className={disabled ? "Mui-disabled" : ""}>
                    <input {...getInputProps()} type="file" multiple style={{ display: "none" }}/>
                    <CloudUploadRounded color="primary" sx={{ fontSize: "5rem" }}/>
                    <Typography mt={.5} fontSize="1.125rem" fontWeight={600}>آپلود فایل</Typography>
                    <Typography mt={1.5} color='primary' fontSize=".875rem" sx={{ display: {xs: "none", lg: "block"} }}>فایل خود را در این قسمت رها کنید</Typography>
                    <Typography mt={1.5} color='primary' fontSize=".875rem" sx={{ display: {lg: "none"} }}>برای آپلود فایل کلیک کنید</Typography>
                    {/* Android more options */}
                    {isAndroid && (
                        <Box onClick={(e) => e.stopPropagation()} sx={{ position: "absolute", top: 0, left: 0, p: 2 }}>
                                <IconButton
                                    onClick={handleOpenOptionsMenu}
                                    color="inherit"
                                    id="more-options-btn"
                                    aria-controls={optionsOpen ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={optionsOpen ? 'true' : undefined}>
                                    <MoreVertRounded/>
                                </IconButton>
                                <Menu
                                    id="more-options-menu"
                                    anchorEl={anchorEl}
                                    open={optionsOpen}
                                    onClose={handleCloseOptionsMenu}>
                                    <MenuItem onClick={(e) => {e.stopPropagation();handleCloseOptionsMenu();recAudioRef.current?.click()}}>
                                        <MicRounded color="error" fontSize="small" sx={{ mr: 1 }}/>
                                        <ListItemText>ضبط صدا</ListItemText>
                                    </MenuItem>
                                    <MenuItem onClick={(e) => {e.stopPropagation();handleCloseOptionsMenu();recImageRef.current?.click()}}>
                                        <CameraAltRounded color="primary" fontSize="small" sx={{ mr: 1 }}/>
                                        <ListItemText>ضبط تصویر</ListItemText>
                                    </MenuItem>
                                </Menu>
                            <input type="file" capture="user" accept="image/*" ref={recImageRef} onChange={(e) => onChange(e.target.files)} style={{ display: "none" }}/>
                            <input type="file" capture="user" accept="audio/*" ref={recAudioRef} onChange={(e) => onChange(e.target.files)} style={{ display: "none" }}/>
                        </Box>
                    )}
                </Wrapper>
            )}
        </Dropzone>
    )
}
export default UploadInput;

const Wrapper = styled(Paper)(({theme}) => ({
    height: "100%",
    minHeight: "50vw",
    position: "relative",
    padding: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    border: "2.5px dashed #6A6A6A",
    userSelect: "none",
    cursor: "pointer",
    borderRadius: 8,
    transition: "all .2s ease",
    [theme.breakpoints.up('lg')]: {minHeight: "25vw"},
    [theme.breakpoints.up('xl')]: {minHeight: "20vw"},
    "&.Mui-disabled": {
        filter: 'grayscale(1)',
        cursor: "not-allowed",
    },
    "&:not(.Mui-disabled):hover": {
        backgroundColor: theme.palette.grey.light
    }
}));
